import type { Component } from '@/types'
import type {
  RecordStrategy,
  RecordStrategyArgs,
  SearchableData,
} from '../types'
import { useComponents } from '@/store/modules/App/component'
import { getSanitizedComponentName } from '@/utils/specifics'
import { blockTypeFromComponent } from '@/types/blockType'

export class ComponentsRecord implements RecordStrategy {
  async get({ spaceId }: RecordStrategyArgs): Promise<Component[]> {
    if (!spaceId) {
      return []
    }

    try {
      return useComponents().getComponents
    } catch (error) {
      console.error('Error fetching components', error)
      return []
    }
  }

  async set(args?: RecordStrategyArgs): Promise<void> {
    const { spaceId } = args || {}
    if (!spaceId) {
      return
    }
    const componentData = await this.get(args || {})

    window?.CommandBar?.addRecords(
      'components',
      this.createSearchableRecord(componentData, spaceId),
    )
  }

  remove(): void {
    window?.CommandBar?.addRecords('components', [])
  }

  createSearchableRecord(
    records: Component[],
    spaceId: string,
  ): SearchableData[] {
    return records.map((item: Component) => ({
      spaceId,
      id: item.id,
      title: item.name,
      label: item.name,
      presets: item.all_presets.length,
      type: item.is_nestable ? 'Nestable' : 'Component',
      description: `${getSanitizedComponentName(item.name)} · ${item.all_presets.length} presets · ${blockTypeFromComponent(item)}`,
    }))
  }
}
